const AUTHORIZATION = "Authorization";

export default AUTHORIZATION;